module.exports = __webpack_public_path__ + "media/images/game/logo_rozpoctisito-5abf2cb2289ab7275d93284c10c01ed8.png";